module.exports = __webpack_public_path__ + "img/Differentiation-PDAC_GSE111672.1124a8b1.png";